import React, { useState, useEffect, useContext } from 'react';
import { ParamsContext } from '../Context/ParamsContext';
import axios from '../../util/Api';
import { message } from 'antd';
import Auxiliary from '../../util/Auxiliary';
import Table from '../../components/Table/Basic';
import { Link } from 'react-router-dom';

const columns = [
  {
    title: 'Nama Perusahaan',
    dataIndex: 'name',
    key: 'name',
    sorter: true,
    filter: true
  },
  {
    title: 'Divisi',
    dataIndex: 'division',
    key: 'division',
    render: division => division.label
  },
  {
    title: 'Kode Perusahaan',
    dataIndex: 'code',
    key: 'code',
    filter: true
  },
  {
    title: 'Total Registrasi',
    dataIndex: 'passport',
    key: 'passport',
    sorter: true,
  },
  {
    title: 'Presence Today',
    dataIndex: 'presence',
    key: 'presence',
    sorter: true,
    render: presence => presence.daily
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: status => status.label
  },
];

const Classification = (props) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalData, setTotalData] = useState(null);

  const params = useContext(ParamsContext);

  useEffect(() => {
    fetchVendorList();
  }, [params]);

  const fetchVendorList = () => {
    setLoading(true);
    const url = `/vendor/list`;
    axios.get(url, { params: params }).then(({ data }) => {
      setData(data.vendors);
      setTotalData(data.total);
      setLoading(false);
    }).catch(err => {
      message.error(`Error: ${err}`);
    });
  }
  return (
    <Auxiliary>
      <h1 className="title gx-mb-4">Perusahaan</h1>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        total={totalData}
        pathname="/vendor/classification"
      />
    </Auxiliary>
  );
}

export default Classification;